module.exports = __webpack_public_path__ + "img/logo_2.84aa21a8.png";